import {parseISO, sub} from "date-fns";

import {monthWhenVerbose} from "@pg-mono/string-utils";

/**
 * Month and year of the data a FAQ answer talks about, both from the SAME date - taking the year from "now"
 * would render December data as next year through all of January.
 *
 * `parseISO`, not `new Date(...)`, keeps local midnight instead of slipping a UTC-behind host to the wrong
 * month. With no date, falls back to the previous month - the statistics database is always a month behind.
 */
export const getReportPeriod = (dateString?: string | null): {month: string | undefined; year: number} => {
    const date = dateString ? parseISO(dateString) : sub(new Date(), {months: 1});

    return {
        month: monthWhenVerbose(date.getMonth() + 1),
        year: date.getFullYear()
    };
};
import {parseISO, sub} from "date-fns";

import {monthWhenVerbose} from "@pg-mono/string-utils";

/**
 * Month and year of the data a FAQ answer talks about, both from the SAME date - taking the year from "now"
 * would render December data as next year through all of January.
 *
 * `parseISO`, not `new Date(...)`, keeps local midnight instead of slipping a UTC-behind host to the wrong
 * month. With no date, falls back to the previous month - the statistics database is always a month behind.
 */
export const getReportPeriod = (dateString?: string | null): {month: string | undefined; year: number} => {
    const date = dateString ? parseISO(dateString) : sub(new Date(), {months: 1});

    return {
        month: monthWhenVerbose(date.getMonth() + 1),
        year: date.getFullYear()
    };
};
